import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../tealium/data_layer';

const defaultData: IDataLayer = {
  event_name: 'cart_sample_removed',
  event_category: 'viewcart',
  event_action: 'cart_sample_removed',
  event_label: null // <sample name - SKU ID - sample category>
};

function trackSampleRemoved(_: string, eventData: IDataLayer = {}) {
  if (eventData && eventData.cart_sample) {
    eventData.event_label = eventData.cart_sample;
  }
  tealium.evtLink({ ...defaultData, ...eventData });
}

registerAnalyticsEventHandler('checkoutSampleRemoved', trackSampleRemoved);
